import { useParams, Link, Navigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { ArrowLeft } from 'lucide-react';
import { PageHeader } from '@/components/ui/Card';
import { ThreadChat } from '@/components/creative/ChatBox';
import { fetchClient, qk } from '@/lib/queries';

/** /chats/company and /chats/client/:id : one room, full height. */
export default function ChatThreadPage({ kind }: { kind: 'company' | 'client' }) {
  const { id = '' } = useParams<{ id: string }>();
  const client = useQuery({ queryKey: qk.client(id), queryFn: () => fetchClient(id), enabled: kind === 'client' && !!id });
  if (kind === 'client' && !id) return <Navigate to="/chats" replace />;
  const title = kind === 'company' ? 'KAF Warehouse' : (client.data?.name ?? 'Clinic');
  const subtitle = kind === 'company'
    ? 'Everyone at KAF. Internal only.'
    : 'The team on this clinic, internal only. The clinic never sees this room; talk with them on Client chats.';
  return (
    <div className="max-w-4xl">
      <Link to="/chats" className="inline-flex items-center gap-1 text-xs text-muted hover:text-accent-400 mb-3"><ArrowLeft size={12} /> All chats</Link>
      <PageHeader title={title} subtitle={subtitle} />
      <ThreadChat kind={kind} id={kind === 'company' ? 'kaf' : id} tall />
    </div>
  );
}
